/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import EnableForProjectState from '../../../features/security/EnableForProjectState';
import CommentEditor from '../../plugins/CommentEditor';
import { getComments } from '../../../features/comments/commentsSlice';
import featureFlags from '../../helpers/featureFlags';
import CommentPanel from './CommentPanel';

type Props = {
  projectId: number;
};

// TODO typed EnableForProjectState
type EnableForProjectStateProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  isProjectDisabled: boolean;
};

const CommentPanelContainer = ({ projectId }: Props): JSX.Element | null => {
  const {
    entityId,
    entityType,
    entityVersion,
    versionRequired,
    isEntitySharedWithClient,
    showCommentsPanel,
    commentPanelOpened, // TODO typed selectors: don't use it,
    embedEditor = true,
  } = useSelector(getComments);

  const versionReadyOrNotNeeded = !(versionRequired && entityVersion === -1);
  const guardEntityVersion = versionRequired ? entityVersion : -1;
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  if (showCommentsPanel && versionReadyOrNotNeeded) {
    const containerClassName = classnames(
      'comment-panel',
      isPwcUser ? 'current-user-is-pwc' : 'current-user-is-client',
      {
        'selection-comments-disabled': !featureFlags.selectionCommentsEnabled,
      }
    );
    return (
      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }: EnableForProjectStateProps) => (
          <div
            className={containerClassName}
            data-testid="comment-panel-container"
          >
            {commentPanelOpened && embedEditor && (
              <span hidden data-testid="comment-editor">
                <CommentEditor
                  entityType={entityType}
                  entityId={entityId as number}
                  entityVersion={guardEntityVersion}
                  isEntitySharedWithClient={isEntitySharedWithClient as boolean}
                  isProjectDisabled={isProjectDisabled}
                  loadComments
                  onSelectionChange={undefined}
                  formattingPlugin={undefined}
                >
                  {undefined}
                </CommentEditor>
              </span>
            )}
            <CommentPanel projectId={projectId} />
          </div>
        )}
      </EnableForProjectState>
    );
  }
  return null;
};

export default CommentPanelContainer;
